import { UtilConfigAnalytics } from './../../utils/configuracoes/util-config-analytics';
import { GoogleAnalyticsService } from './../../analytics/google-analytics.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AutenticaoService } from 'src/app/auth/autenticacao.service';
import { FalhaServico } from 'src/app/models/falha-servico';
import { UtilLarguraTela } from 'src/app/utils/configuracoes/util-largura-tela';
import { UtilBloco } from 'src/app/utils/util.bloco';
import { environment } from 'src/environments/environment';
import { FotografiaService } from './fotografia/fotografia.service';
import { RelatorioSinteticoService } from './relatorio-sintetico.service';


@Component({
  selector: 'app-relatorio-sintetico',
  templateUrl: './relatorio-sintetico.component.html',
  styleUrls: ['./relatorio-sintetico.component.scss']
})
export class RelatorioSinteticoComponent implements OnInit {

  lgpdRelatorioSintetico: string = 'lgpd-relatorio-sintetico';

  public loadingUser: number = 0;
  public showLoading: boolean;
  public ativo = true;
  public executar = false;
  public falhaServico: FalhaServico;
  public listaServicoFalha: Array<string>;
  public larguraEhSuperiorMin: boolean;

  public totalDividasGerais: number = 0;
  public totalInformacaoPositivo: number = 0;
  public mensagemPositivo: string = '';
  public totalDividasPublicasResolvidas: number = 0;

  public loadModalRelAnalitico: boolean = false;
  constructor(private cookieService: CookieService, private router: Router, private fotografiaService: FotografiaService, private relatorioSinteticoService: RelatorioSinteticoService, private autenticaoService: AutenticaoService, private googleAnalyticsService: GoogleAnalyticsService) {
    this.googleAnalyticsService.pushTag(UtilConfigAnalytics.ConfigAnalytics('page_view', null, null, 'logado', null, 'Serasa Institucional - LGPD - Relatorio Sintetico', null, this.lgpdRelatorioSintetico));
    this.googleAnalyticsService.pushTag(UtilConfigAnalytics.ConfigAnalytics('page_view_ga4', null, null, 'logado', null, 'Serasa Institucional - LGPD - Relatorio Sintetico', null, this.lgpdRelatorioSintetico));

    this.googleAnalyticsService.pushTag(UtilConfigAnalytics.ConfigAnalytics('entrar-tela', null, null, 'logado', 'relatorio-sintetico', null, null, this.lgpdRelatorioSintetico));
    this.googleAnalyticsService.pushTag(UtilConfigAnalytics.ConfigAnalytics('entrar-tela-ga4', null, null, 'logado', null, null, 'relatorio-sintetico', this.lgpdRelatorioSintetico));


    this.checarAcessoViaRedirect(),
      this.falhaServico = new FalhaServico();
  }

  checarAcessoViaRedirect() {
    sessionStorage.setItem('pathRedirect', '/relatorio-sintetico');
    if (sessionStorage.getItem("accessTokenJWT") == null) {
      if (!this.cookieService.get('Valgrind-AU')) {
        window.location.href = environment.urlPortal + "/entrar?redirectUrl=" + environment.urlRedirecionamentoRelatorioSintetico;
      }
      this.autenticaoService.accessTokenExiste.subscribe(res => {
        if (res) {
          this.executar = res;
        }
      });
    } else {
      this.executar = true;
    }
  }

  ngOnInit(): void {
    this.checarAcessoViaRedirect();
    this.falhaServico = new FalhaServico();
    this.listaServicoFalha = new Array();
    this.larguraEhSuperiorMin = UtilLarguraTela.checarLarguraTela();

  }

  carregamentoTela($event) {
    if (UtilBloco.blocosSintetico().includes($event)) {
      this.loadingUser = this.loadingUser + 1
      if (this.loadingUser == UtilBloco.blocosSintetico().length) {
        this.ativo = false;
        this.showLoading = false;
      }
    }
    setTimeout(() => {
      if (this.loadingUser !== UtilBloco.blocosSintetico().length) {
        sessionStorage.setItem("idErro", '2004');
        this.router.navigate(['/erro']);
      }
    }, 20000);
  }

  getTotalDividasRegularizadasAcoesJudiciais($event) {
    this.totalDividasPublicasResolvidas = this.totalDividasPublicasResolvidas + $event;
  }

  getTotalDividasRegularizadasAcoesProtestos($event) {
    this.totalDividasPublicasResolvidas = this.totalDividasPublicasResolvidas + $event;
  }

  getTotalDividasRegularizadasAcoesChequesSemFundos($event) {
    this.totalDividasPublicasResolvidas = this.totalDividasPublicasResolvidas + $event;
  }

  getTotalDividasAcoesJudiciais($event) {
    this.totalDividasGerais = this.totalDividasGerais + $event;
  }

  getTotalDividasChequeSemFundo($event) {
    this.totalDividasGerais = this.totalDividasGerais + $event;
  }

  getTotalDividasParticipacaoFalencia($event) {
    this.totalDividasGerais = this.totalDividasGerais + $event;
  }

  getTotalDividasProtestos($event) {
    this.totalDividasGerais = this.totalDividasGerais + $event;
  }

  getTotalInformacoesPositivo($event) {
    this.totalInformacaoPositivo = this.totalInformacaoPositivo + $event;
  }
  getMensagemPositivoPositivo($event) {
    this.mensagemPositivo = $event
  }


  // abrirModalSolicitarRelAnalitico() {
  //   this.loadModalRelAnalitico = true;
  //   if(this.modalRelatorioAnalitico !== undefined){
  //     this.modalRelatorioAnalitico.openNewModal();
  //   }
  // }
}
